import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const ScrollingBanner = ({
  items = [
    "Passion and Progress",
    "Founders and Vision",
    "Growth and Impact",
    "Team and Values",
  ],
  separatorIcon = "✱",
}) => {
  const firstGroupRef = useRef(null);
  const [groupWidth, setGroupWidth] = useState(0);

  /* --------------------------------------------------------------- */
  /* GET EXACT WIDTH OF ONE COMPLETE GROUP                           */
  /* --------------------------------------------------------------- */

  useEffect(() => {
    const updateWidth = () => {
      if (firstGroupRef.current) {
        setGroupWidth(firstGroupRef.current.offsetWidth);
      }
    };

    updateWidth();

    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, [items]);

  /* --------------------------------------------------------------- */
  /* SINGLE ITEM                                                     */
  /* --------------------------------------------------------------- */

  const renderItems = (groupRef = null) => (
    <div
      ref={groupRef}
      className="flex shrink-0 items-center whitespace-nowrap"
    >
      {items.map((text, index) => (
        <React.Fragment key={`${text}-${index}`}>
          {/* Text */}
          <span
            className="
              shrink-0
              px-6
              font-saira
              text-lg
              font-medium
              tracking-wide
              text-black
              sm:px-6
              sm:text-lg
              md:px-8
              md:text-xl
              lg:px-10
              lg:text-2xl
            "
          >
            {text}
          </span>

          {/* Separator */}
          <span
            className="
              shrink-0
              text-xl
              font-bold
              leading-none
              text-black
              sm:text-xl
              md:text-2xl
            "
          >
            {separatorIcon}
          </span>
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <section className="relative w-full overflow-hidden bg-primaryColor py-2 sm:py-3 md:py-4">
      {/* ----------------------------------------------------------- */}
      {/* MARQUEE                                                      */}
      {/* ----------------------------------------------------------- */}

      <motion.div
        className="flex w-max items-center"
        animate={
          groupWidth > 0
            ? {
                x: [0, -groupWidth],
              }
            : {
                x: 0,
              }
        }
        transition={{
          x: {
            duration: 26,
            ease: "linear",
            repeat: Infinity,
            repeatType: "loop",
          },
        }}
      >
        {/* FIRST EXACT GROUP */}
        {renderItems(firstGroupRef)}

        {/* SECOND EXACT GROUP */}
        {renderItems()}
      </motion.div>
    </section>
  );
};

export default ScrollingBanner;